import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useUnlockLegalClientMutation } from 'api/generated/graphql';
import { useError } from 'api/helpers';

export const useUnlockLegalClient = () => {
  const [handle, { loading, error: apolloError }] =
    useUnlockLegalClientMutation();

  const error = useError(apolloError);

  return {
    loading,
    error,
    unlock: useCallback(
      async (id: string) => {
        const res = await handle({ variables: { id } });
        return !!res.data?.unlock;
      },
      [handle]
    ),
  };
};
